import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronDown } from 'lucide-react';
import { forwardRef } from 'react';
import { cn } from './cn.js';
const SELECT_CLASSES = 'flex h-11 w-full appearance-none rounded-md border border-input bg-card pl-3 pr-9 text-sm text-foreground ' +
    'transition-colors duration-[var(--dur-quick)] ' +
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:border-ring ' +
    'aria-[invalid=true]:border-destructive aria-[invalid=true]:focus-visible:ring-destructive ' +
    'disabled:cursor-not-allowed disabled:bg-disabled disabled:text-disabled-foreground ' +
    'disabled:outline-1 disabled:-outline-offset-1 disabled:outline-disabled-foreground';
/**
 * Token-driven native <select>. Native means free keyboard + mobile behaviour;
 * we only restyle the box and overlay a chevron. Pass <option>s as children.
 */
export const Select = forwardRef(({ className, children, ...props }, ref) => (_jsxs("div", { className: "relative w-full", children: [_jsx("select", { ref: ref, className: cn(SELECT_CLASSES, className), ...props, children: children }), _jsx(ChevronDown, { className: "pointer-events-none absolute right-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground", "aria-hidden": "true" })] })));
Select.displayName = 'Select';
